import { Pill } from './Pill';
import type { SemanticColor } from './semanticColor';

const COLOR_MAP: Record<string, SemanticColor> = {
  ACTIVE: 'success',
  DONE: 'success',
  PENDING: 'warning',
  IN_PROGRESS: 'cyan',
  DISABLED: 'error',
  FAILED: 'error',
  LOW: 'success',
  MEDIUM: 'warning',
  HIGH: 'error',
};

/** Status / priority pill — colors come from a small status→color map. */
export function StatusChip({ value }: { value: string | null | undefined }) {
  if (!value) return null;
  const color = COLOR_MAP[value] ?? 'neutral';
  return (
    <Pill color={color} mono={false}>
      {value}
    </Pill>
  );
}
